module.exports = __webpack_public_path__ + "img/wxkf3.0dbf877c.png";